"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVirtualCategory = void 0;
const routes_1 = require("../../routes");
const createVirtualCategory = (client) => async (params, data) => {
    const url = routes_1.ENDPOINTS.CREATE_VIRTUAL_CATEGORY.applyParams(params);
    const response = await client.post(url, data);
    return response.data;
};
exports.createVirtualCategory = createVirtualCategory;
